import React from 'react';
import LoginComponent from "../../component/dashboard/user/login";

function LoginPage() {
  return (
    <>
      <LoginComponent />
    </>
  );
}

export default LoginPage;
